import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalRef,
  NgbModule,
  NgbNavModule,
} from "@ng-bootstrap/ng-bootstrap";
import { HostListener } from '@angular/core';
//Services
import { TiposEspecialistaService } from "src/app/core/services/tipo-especialista.service";
import { EspecialidadesService } from "src/app/core/services/especialidades.service";
import { EspecialistaService } from "src/app/core/services/especialista.service";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { SedeService } from "src/app/core/services/sede.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { Especialista } from "src/app/core/models";
//Services
import { CalendarioComponent } from "../calendario/calendario.component";
import { PacientesService } from "src/app/core/services/paciente.service";
import { ConvenioService } from "src/app/core/services/convenio.service";
import { CommonModule, DatePipe } from "@angular/common";
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedModule } from "src/app/shared/shared.module";
import { ExpandableTextComponent } from "./expandible.component";
import { EspecialistaTarifaService } from "src/app/core/services/especialista-tarifa.service";
import { CitaService } from "src/app/core/services/cita.service";

@Component({
  standalone: true,
  selector: "app-citas-list",
  templateUrl: "./citas-list.component.html",
  styleUrls: ["./citas-list.component.scss"],
  imports: [
    CommonModule,
    NgSelectModule,
    NgbModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ExpandableTextComponent,
  ],
})
export class CitasListComponent implements OnInit {
  @ViewChild("showSchedule") modalProgramar!: TemplateRef<any>;
  idPaciente: string = "";
  datosPaciente: any;
  pacienteAntiguo: boolean = false;

  // bread crumb items
  breadCrumbItems!: Array<{}>;
  especialistasFiltrados: any[] = [];
  tiposEspecialistas = [];
  especialidades = [];
  especialistas: Especialista[] = [];
  offset: number = 0;
  limit: number = 6;
  loading: boolean = false;
  endReached: boolean = false;
  convenios = [];
  servicios = [];
  sedes = [];
  formData: FormGroup = new FormGroup({});
  spinner: Boolean = true;
  //Filtros
  searchTipoEspecialista: string = "";
  searchServicio: string = "";
  searchEspecialidad: string = "";
  searchSede: string = "";

  nombreEspecialista: string = "";

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private __sedeService: SedeService,
    private formBuilder: UntypedFormBuilder,
    private __convenioService: ConvenioService,
    private __pacientesService: PacientesService,
    private __serviciosService: ServiciosService,
    private __especialistasService: EspecialistaService,
    private __especialidadesService: EspecialidadesService,
    private __tiposEspecialistaService: TiposEspecialistaService,
    private __especialistaTarifaService: EspecialistaTarifaService,
    public router: Router,
    private __citasservice: CitaService
  ) {}

  ngOnInit(): void {
    this.spinner = true;
    this.route.queryParams.subscribe((params) => {
      this.searchSede = params["sede"] ? params["sede"] : null;
      this.searchServicio = params["servicio"] ? params["servicio"] : null;
      this.searchEspecialidad = params["especialidad"]
        ? params["especialidad"]
        : null;
      this.searchTipoEspecialista = params["tipoEspecialista"]
        ? params["tipoEspecialista"]
        : null;
      this.nombreEspecialista = params["nombreEspecialista"]
        ? params["nombreEspecialista"]
        : null;
    });

    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.idPaciente = JSON.parse(currentUser).userId;
      this.getPaciente(this.idPaciente);
    }

    this.formData = this.formBuilder.group({
      sede: [],
      servicio: [],
      especialidad: [],
      tipoEspecialista: [],
    });

    this.getSedes((data: any) => {
      this.sedes = data;
    });
    this.getServicios((data: any) => {
      this.servicios = data;
    });
    this.getEspecialidades((data: any) => {
      this.especialidades = data;
    });
    this.getTipoEspecialistas((data: any) => {
      this.tiposEspecialistas = data.map((item: any) => ({
        id: item.$id,
        especialidad: item.especialidad
      }));
    });

    // this.__especialistaTarifaService.algoAqui().then((data: any) => {
    //   console.log('ALGO AQUI:: ',data)
    // })
  }

  /**
   *
   * @param idPaciente
   */
  async getPaciente(idPaciente: string) {
    this.__pacientesService.getDocument(idPaciente).then((res: any) => {
      this.datosPaciente = res;
      if (this.datosPaciente.idEmpresa) {
        this.__convenioService
          .getConveniosEmpresaActive(this.datosPaciente.idEmpresa.$id)
          .then((convenios: any) => {
            this.convenios = convenios;
          })
          .catch((error) => {
            console.log(
              "error al consultar informacion de los convenios",
              error
            );
          });
      }
    });

    // VALIDAR SI ES PACIENTE NUEVO O NO Para luego filtrar los especialistas por el atributo soloPacientesAntiguos
    await this.__citasservice.getLastCita(idPaciente).then((res: any) => {
      this.pacienteAntiguo = res ? true : false;
    });
    console.log("PACIENTE ANTIGUO: ", this.pacienteAntiguo);

    this.getEspecialistas();
  }

  /**
   * @getSedes()
   * @param dataComp
   */
  getSedes(dataComp: any) {
    this.__sedeService.getSedes().then((data) => {
      dataComp(data.documents);
    });
  }

  /**
   * @getServicios()
   * @param dataComp
   */
  getServicios(dataComp: any) {
    this.__serviciosService.getData().then((data) => {
      dataComp(data);
    });
  }

  /**
   * @getTipoEspecialistas()
   * @param dataComp
   */
  getTipoEspecialistas(dataComp: any) {
    this.__tiposEspecialistaService.getTiposDocumento().then((data) => {
      console.log('Tipos Especialistas:', data);
      dataComp(data);
    });
  }

  /**
   * @getEspecialidades()
   * @param dataComp
   */
  getEspecialidades(dataComp: any) {
    this.__especialidadesService.getData().then((data) => {
      dataComp(data);
    });
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    const buffer = 100;

    const reachedBottom = scrollTop + windowHeight >= documentHeight - buffer;

    if (reachedBottom && !this.loading && !this.endReached && !this.scrolling) {
      this.getEspecialistas();
    }
  }

  /**
   * getEspecialistas()
   */
  scrolling = false;
  getEspecialistas(): void {
    this.scrolling = true;
    this.loading = true;
    this.spinner = true;
    
    // Se llama a la función getEspecialistasComplete, para mostrar los especialistas 
    this.__especialistasService.getEspecialistasComplete(this.pacienteAntiguo, this.offset, this.limit)
      .then((response: Especialista[]) => {
        if (response.length < this.limit) {
          this.endReached = true;
        }
  
        // Evita duplicados por ID
        const nuevos = response.filter((nuevo) =>
          !this.especialistas.some((e) => e.$id === nuevo.$id)
        );
  
        this.especialistas.push(...nuevos);
  
        // Aplica los filtros solo si ya hay criterios activos
        if (
          this.searchSede ||
          this.searchServicio ||
          this.searchEspecialidad ||
          this.searchTipoEspecialista ||
          this.nombreEspecialista
        ) {
          this.filtrarDatos();
        } else {
          this.especialistasFiltrados = [...this.especialistas];
        }
  
        this.offset += this.limit;
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
        this.spinner = false;
        this.scrolling = false;
      });
  }

  // Filtra los especialistas obtenidos segun lo buscado en el formulario
  getEspecialidadPorId(id: string): string {
    const tipo = this.tiposEspecialistas.find(t => t.id === id);
    return tipo?.especialidad ?? '';
  }
  filtrarDatos() {
    this.spinner = true;
    this.especialistasFiltrados = this.especialistas;
    console.log("🔍 Buscando especialistas con perfil.$id ===", this.searchTipoEspecialista);
    console.log("Primer especialista:", this.especialistasFiltrados[0]?.perfil);
    console.log("🧪 especialista:", this.especialistas[0]);
    console.log("➡️ Tipo de perfil:", typeof this.especialistas[0]?.perfil);
    console.log("➡️ Valor de perfil:", this.especialistas[0]?.perfil);

    if (this.searchTipoEspecialista) {
      const nombreEspecialidad = this.getEspecialidadPorId(this.searchTipoEspecialista);
      console.log("🔎 Nombre de especialidad buscada:", nombreEspecialidad);

      this.especialistasFiltrados = this.especialistasFiltrados.filter(
        (especialista) => especialista.perfil?.especialidad === nombreEspecialidad
      );

      // DEBUG: Mostrar el primer especialista que cumple con el filtro
      if (this.especialistasFiltrados.length > 0) {
        console.log("✅ Primer especialista filtrado:", this.especialistasFiltrados[0]);
      } else {
        console.warn("⚠️ No se encontró ningún especialista con esa especialidad.");
      }
    }

    if (this.searchServicio) {
      this.especialistasFiltrados = this.especialistasFiltrados.filter(
        (especialista) =>
          especialista.servicios.some(
            (t: any) => t.servicioId.$id === this.searchServicio
          )
      );
    }

    if (this.searchEspecialidad) {
      this.especialistasFiltrados = this.especialistasFiltrados.filter(
        (especialista) =>
          especialista.especialidades.some(
            (t: any) => t.tEspecialidad.$id === this.searchEspecialidad
          )
      );
    }

    if (this.searchSede) {
      this.especialistasFiltrados = this.especialistasFiltrados.filter(
        (especialista) =>
          especialista.agenda.some(
            (t: any) => t.idSedeConsultorio.idSede.$id === this.searchSede
          )
      );
    }

    // if (this.searchSede) {
    //   this.especialistasFiltrados = this.especialistasFiltrados.filter(
    //     (especialista) => {
    //       // Verifica si especialista.agenda existe y es un array
    //       if (!especialista.agenda || !Array.isArray(especialista.agenda)) {
    //         return false;
    //       }

    //       // Usa some con validaciones en cada nivel
    //       return especialista.agenda.some((t: any) => {
    //         return t &&
    //                t.idSedeConsultorio &&
    //                t.idSedeConsultorio.idSede &&
    //                t.idSedeConsultorio.idSede.$id === this.searchSede;
    //       });
    //     }
    //   );
    // }

    if (this.nombreEspecialista) {
      this.especialistasFiltrados = this.especialistasFiltrados.filter(
        (especialista) =>
          this.nombreEspecialista
            .toLowerCase()
            .split(" ")
            .every((palabra) =>
              especialista.nombre.toLowerCase().includes(palabra)
            )
      );
    }
    this.spinner = false;
  }

  // Muestra el modal del calendario para seleccionar una hora
  showAgenda(datos: any) {
    // TODO: Revisar todos los datos pasados al modal se envia información sensible
    // console.log("datos enviados al modal:::", datos);
    const modalRef: NgbModalRef = this.modalService.open(CalendarioComponent, {
      size: "md",
      windowClass: "calendario-modal",
    });
    if (this.idPaciente) {
      this.datosPaciente.convenios = this.convenios;
      datos.datosPaciente = this.datosPaciente;
    }
    modalRef.componentInstance.datos = datos; // Pasar datos al componente modal
  }

  /**
   *
   */
  get form() {
    return this.formData.controls;
  }
}
